export default __webpack_public_path__ + "static/media/640_dummy2016-restaurant02-de.252008b3.png";